import type { ReactElement } from "react";
import { getFontFamily } from "@/theme/typography";
import { COMPACT_BAR_FILL_BG, COMPACT_BAR_FILL_SHADOW, COMPACT_BAR_TRACK_BACKGROUND, COMPACT_BAR_TRACK_SHADOW, } from "./kanban-view-constants";
import { getCompactPreviewColumns } from "./kanban-selectors";
import type { ParsedKanban } from "./parse-mermaid-kanban";
interface KanbanCompactPreviewProps {
    parsed: ParsedKanban;
}
export function KanbanCompactPreview({ parsed, }: KanbanCompactPreviewProps): ReactElement | null {
    if (parsed.columns.length === 0) {
        return null;
    }
    const columns = getCompactPreviewColumns(parsed);
    const maxCount = Math.max(...columns.map((column) => column.cards.length), 1);
    return (
      <div style={{
            display: "flex",
            flexDirection: "column",
            height: "100%",
            gap: 13,
            padding: "0 2px 26px",
            justifyContent: "center",
        }}>
        {columns.map((column, columnIndex) => {
            const percent = (column.cards.length / maxCount) * 100;
            return (<div key={column.id} style={{ display: "flex", alignItems: "center", gap: 7 }}>
              <span style={{
                    fontFamily: getFontFamily(),
                    fontSize: 14,
                    textTransform: "uppercase",
                    width: 30,
                    color: "rgba(255,255,255,0.65)",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    flexShrink: 0,
                }}>
                {column.label.slice(0, 3)}
              </span>
              <div style={{
                    flex: 1,
                    height: 13,
                    borderRadius: 999,
                    backgroundColor: COMPACT_BAR_TRACK_BACKGROUND,
                    boxShadow: COMPACT_BAR_TRACK_SHADOW,
                    padding: 3,
                }}>
                <div style={{
                    height: "100%",
                    width: `${percent}%`,
                    backgroundImage: COMPACT_BAR_FILL_BG[columnIndex % COMPACT_BAR_FILL_BG.length],
                    borderRadius: 999,
                    boxShadow: COMPACT_BAR_FILL_SHADOW[columnIndex % COMPACT_BAR_FILL_SHADOW.length],
                }}/>
              </div>
                <span style={{
                    fontFamily: getFontFamily(),
                    fontSize: 15,
                    fontWeight: "bold",
                    width: 13,
                    textAlign: "right",
                    color: "rgba(255,255,255,0.5)",
                    flexShrink: 0,
                }}>
                {column.cards.length}
              </span>
            </div>);
        })}
      </div>
    );
}
